// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer
 *  layout only. Tokens and ui-* classes come from siteShell.css.
 */

.site-footer {
  margin-top: auto;
  background: var(--bg);
  border-top: 1px solid var(--border-light);
  color: var(--text-primary);
}

.site-footer-inner {
  width: 100%;
  max-width: var(--container);
  margin: 0 auto;
  padding: var(--space-8) var(--gutter) var(--space-5);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
}

.site-footer-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 2fr);
  gap: var(--space-6);
  align-items: start;
}

.site-footer-brand {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: 0;
}

.site-footer-logo {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  align-self: flex-start;
  min-height: 36px;
  color: var(--primary);
  text-decoration: none;
}

.site-footer-logo-img {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-sm);
  display: block;
}

.site-footer-logo-text {
  font-size: 1.0625rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.018em;
}

.site-footer-tagline {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary);
  max-width: 40ch;
}

.site-footer-nav {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-5);
}

.site-footer-col {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.site-footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.site-footer-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2);
  min-height: 32px;
}

.site-footer-link {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.45;
  color: var(--text-secondary);
  text-decoration: none;
  transition: color var(--dur-fast) var(--ease-standard);
}

.site-footer-link:hover {
  color: var(--primary);
}

.site-footer-bottom {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: var(--space-2) var(--space-4);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-light);
}

.site-footer-fine-print {
  margin: 0;
  font-size: 0.8125rem;
  line-height: 1.5;
  color: var(--text-secondary);
}

.site-footer-mail {
  font-size: 0.8125rem;
  line-height: 1.5;
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  overflow-wrap: anywhere;
}

@media (max-width: 820px) {
  .site-footer-grid {
    grid-template-columns: minmax(0, 1fr);
  }

  .site-footer-nav {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 480px) {
  .site-footer-inner {
    padding-top: var(--space-6);
    gap: var(--space-5);
  }

  .site-footer-grid {
    gap: var(--space-5);
  }

  .site-footer-nav {
    gap: var(--space-4);
  }

  .site-footer-link {
    font-size: 0.8125rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .site-footer-link {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,oDAAoD;EACpD,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Footer\n *  layout only. Tokens and ui-* classes come from siteShell.css.\n */\n\n.site-footer {\n  margin-top: auto;\n  background: var(--bg);\n  border-top: 1px solid var(--border-light);\n  color: var(--text-primary);\n}\n\n.site-footer-inner {\n  width: 100%;\n  max-width: var(--container);\n  margin: 0 auto;\n  padding: var(--space-8) var(--gutter) var(--space-5);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-6);\n}\n\n.site-footer-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 2fr);\n  gap: var(--space-6);\n  align-items: start;\n}\n\n.site-footer-brand {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n  min-width: 0;\n}\n\n.site-footer-logo {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--space-2);\n  align-self: flex-start;\n  min-height: 36px;\n  color: var(--primary);\n  text-decoration: none;\n}\n\n.site-footer-logo-img {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-sm);\n  display: block;\n}\n\n.site-footer-logo-text {\n  font-size: 1.0625rem;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: -0.018em;\n}\n\n.site-footer-tagline {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n  max-width: 40ch;\n}\n\n.site-footer-nav {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-5);\n}\n\n.site-footer-col {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-1);\n  min-width: 0;\n}\n\n.site-footer-links {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.site-footer-row {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n  min-height: 32px;\n}\n\n.site-footer-link {\n  display: inline-flex;\n  align-items: center;\n  min-height: 28px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  line-height: 1.45;\n  color: var(--text-secondary);\n  text-decoration: none;\n  transition: color var(--dur-fast) var(--ease-standard);\n}\n\n.site-footer-link:hover {\n  color: var(--primary);\n}\n\n.site-footer-bottom {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: var(--space-2) var(--space-4);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-light);\n}\n\n.site-footer-fine-print {\n  margin: 0;\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  color: var(--text-secondary);\n}\n\n.site-footer-mail {\n  font-size: 0.8125rem;\n  line-height: 1.5;\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  overflow-wrap: anywhere;\n}\n\n@media (max-width: 820px) {\n  .site-footer-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .site-footer-nav {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 480px) {\n  .site-footer-inner {\n    padding-top: var(--space-6);\n    gap: var(--space-5);\n  }\n\n  .site-footer-grid {\n    gap: var(--space-5);\n  }\n\n  .site-footer-nav {\n    gap: var(--space-4);\n  }\n\n  .site-footer-link {\n    font-size: 0.8125rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .site-footer-link {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
